import { useEffect, useMemo, useState } from "react"

const contactContent = {
  mobile: {
    title: "Call Us",
    logo: "/images/icon/contact-us/mobile-app-icon.webp",
    content: "+63-2-8-6263222",
    qrCode: "/images/qr-code/phoneqr.webp",
  },
  viber: {
    title: "Viber Support",
    logo: "/images/icon/contact-us/viber-app-icon.webp",
    content: "+855-969-845-661",
    qrCode: "/images/qr-code/new-viberqr.webp",
  },
  telegram: {
    title: "Telegram Channel",
    logo: "/images/icon/social-media/telegram.webp",
    content: "@FUNGAMINGHUB",
    qrCode: "/images/qr-code/tgqr-enhanced.webp",
  },
}

export default function ContactUs({ type, types, onClose }) {
  const selectedTypes = useMemo(() => {
    if (Array.isArray(types) && types.length) return types
    if (type) return [type]
    return []
  }, [types, type])

  const contacts = useMemo(() => {
    return selectedTypes
      .map((contactType) => {
        const data = contactContent[contactType]

        if (!data) return null

        return {
          type: contactType,
          ...data,
        }
      })
      .filter((contact) => contact && contact.qrCode)
  }, [selectedTypes])

  const [activeType, setActiveType] = useState(selectedTypes[0])

  useEffect(() => {
    if (!selectedTypes.length) return

    setActiveType((currentType) => {
      return selectedTypes.includes(currentType)
        ? currentType
        : selectedTypes[0]
    })
  }, [selectedTypes])

  const activeContact =
    contacts.find((contact) => contact.type === activeType) || contacts[0]

  if (!activeContact) return null

  const { type: contactType, title, content, qrCode, logo } = activeContact

  return (
    <div className="fgh-contact-us-container fgh-contact-container">
      <div className="fgh-contact-us-container--content fgh-contact-content">
        {contacts.length > 1 && (
          <div
            className="fgh-contact-toggle"
            role="group"
            aria-label="Choose contact"
          >
            {contacts.map((contact) => (
              <button
                key={contact.type}
                type="button"
                className={`fgh-contact-toggle-btn ${
                  activeType === contact.type ? "active" : ""
                }`}
                aria-pressed={activeType === contact.type}
                onClick={() => setActiveType(contact.type)}
              >
                {contact.title.trim().split(/\s+/)[0]}
              </button>
            ))}
          </div>
        )}

        <div className="fgh-contact-list fgh-contact-content-list is-single">
          <div className="fgh-contact-card fgh-card" key={contactType}>
            <div className="fgh-contact-title">{title}</div>
            <a
              href={qrCode}
              download={`FGH_${contactType.toUpperCase()}-QR-CODE.WEBP`}
              className="fgh-qr-download-link"
            >
              <img
                className="fgh-qrcode fgh-qr-pic"
                src={qrCode}
                alt={`${title} QR Code`}
              />

              <span className="contact-download">Download</span>
            </a>

            <p>{content}</p>
          </div>
        </div>

        <button className="contact-close fgh-close" onClick={onClose}>
          Close
        </button>
      </div>
    </div>
  )
}
